<template>
  <BatchDeploy />
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import BatchDeploy from '@/app/features/admin/batch/BatchDeploy.vue';

  export default defineComponent({
    name: 'BatchPage',
    components: {
      BatchDeploy,
    },
  });
</script>


